import { render } from "./EmptyListMessage.vue?vue&type=template&id=2b85bae0&scoped=true"
import script from "./EmptyListMessage.vue?vue&type=script&lang=js"
export * from "./EmptyListMessage.vue?vue&type=script&lang=js"

import "./EmptyListMessage.vue?vue&type=style&index=0&id=2b85bae0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b85bae0"]])

export default __exports__